// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"70df9e88","598":"073b213f","703":"32ed37cd","787":"e05962c6"}[chunkId] + ".chunk.js";
};